import { Button, Flex, Select } from "antd";
import React, { useState } from "react";
import { ProgrammingLanguage } from "../../Interface/Index";
import { ExpandAltOutlined, ShrinkOutlined } from "@ant-design/icons";

interface SettingsProps {
  languages: ProgrammingLanguage[];
  handleSelectLanguage: (language: ProgrammingLanguage | null) => void;
  selectedLanguage: ProgrammingLanguage | null;
  handleFullScreen: () => void;
  isFullScreen: boolean;
}

const Settings: React.FC<SettingsProps> = ({
  handleSelectLanguage,
  languages,
  selectedLanguage,
  handleFullScreen,
  isFullScreen,
}) => {
  const languageOptions = languages.map((language) => ({
    label: language.name,
    value: language.id,
  }));
  const [filteredOptions, setFilteredOptions] = useState(languageOptions);

  return (
    <Flex style={{ width: "100%" }} gap="middle" vertical>
      <Flex
        justify="space-between"
        align="center"
        style={{ width: "100%" }}
        className="languageSelector"
      >
        <div style={{ width: "70%" }}>
          <Select
            value={selectedLanguage?.id}
            options={filteredOptions}
            style={{ width: 200 }}
            placeholder="Select a language"
            onChange={(value) => {
              const selectedLanguage = languages.find(
                (language) => language.id === value
              );
              if (selectedLanguage) {
                handleSelectLanguage(selectedLanguage);
              }
            }}
            showSearch
            filterOption={false}
            onSearch={(searchText) => {
              const filtered = languageOptions.filter((option) =>
                option.label.toLowerCase().includes(searchText.toLowerCase())
              );
              setFilteredOptions(filtered);
            }}
            onFocus={() => setFilteredOptions(languageOptions)}
            getPopupContainer={(trigger) => trigger.parentElement!}
            allowClear
            onClear={() => {
              handleSelectLanguage(null);
            }}
          />
        </div>
        <div className="actions-container">
          <h3 className="output-title-lg" style={{ color: "#000000" }}>
            Output
          </h3>
          <Button
            onClick={handleFullScreen}
            type="text"
            icon={!isFullScreen ? <ExpandAltOutlined /> : <ShrinkOutlined />}
          />
        </div>
      </Flex>
    </Flex>
  );
};

export default Settings;
